import { z } from 'zod';

export const accountRoleSchema = z.enum(['user', 'editor', 'admin']);
export type AccountRole = z.infer<typeof accountRoleSchema>;

export const accountSchema = z.object({
  id: z.string().uuid(),
  pseudo: z.string().min(2).max(32),
  email: z.string().email().nullable(),
  discordId: z.string().nullable(),
  avatarUrl: z.string().url().nullable(),
  role: accountRoleSchema,
  createdAt: z.string().datetime(),
  lastSeenAt: z.string().datetime(),
});
export type Account = z.infer<typeof accountSchema>;
